import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ticket_history"
}
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock p-mr-2" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, "(HH:mm:ss)")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["for"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["id", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TonImageDialog = _resolveComponent("TonImageDialog")!
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_TicketStatus = _resolveComponent("TicketStatus")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TonImageDialog, {
      src: _ctx.tonDialogSrc,
      visible: _ctx.displayTonDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayTonDialog = $event))
    }, null, 8, ["src", "visible"]),
    (!_ctx.history && _ctx.requestPending)
      ? (_openBlock(), _createBlock(_component_TableSkeleton, {
          key: 0,
          columns: 3,
          rows: 5
        }))
      : (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("header", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ticket.history.title')), 1)
          ]),
          _createVNode(_component_DataTable, {
            value: _ctx.history,
            stripedRows: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Status" }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_TicketStatus, {
                    status: data.status,
                    is_free_dumped: data.is_free_dumped
                  }, null, 8, ["status", "is_free_dumped"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Date" }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_DateFormatted, {
                    date: data.created_at,
                    format: "YYYY-MM-DD",
                    tz: data.zone_name
                  }, null, 8, ["date", "tz"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('ticket.history.time')), 1)
                  ])
                ]),
                body: _withCtx(({data, index}) => [
                  (data.status !==  _ctx.TicketStatusEnum.ACCEPTED_BY_USER)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.timeDiffNext(index, data)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.timeZoneDate(data.created_at)), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_Column, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('ticket.history.duration')), 1),
                    _hoisted_6
                  ])
                ]),
                body: _withCtx(({data, index}) => [
                  ( 
                 data.status ===  _ctx.TicketStatusEnum.WAITING_LOAD  
              || data.status ===  _ctx.TicketStatusEnum.LOADED 
              || data.status ===  _ctx.TicketStatusEnum.WAITING_DUMP 
              || data.status ===  _ctx.TicketStatusEnum.DUMPED
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getDurationFrom(index, data)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (!_ctx.hiddenColumns['ton'])
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    header: _ctx.$t('ticket.history.ton')
                  }, {
                    body: _withCtx(({data}) => [
                      (_ctx.isTicketHistoryTonEditable(data))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_InputNumber, {
                              mode: "decimal",
                              minFractionDigits: 1,
                              modelValue: data.ton,
                              "onUpdate:modelValue": ($event: any) => (data.ton = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            (_ctx.editTicketTonVisible(data))
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.editTicketHistoryTon(data)),
                                  icon: "pi pi-check",
                                  class: "p-button-success"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(data.ton), 1))
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (!_ctx.hiddenColumns['ton_image_path_url'])
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    header: _ctx.$t('ticket.history.ton_photo')
                  }, {
                    body: _withCtx(({data}) => [
                      (data.ton_image_path_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "pointer",
                            onClick: ($event: any) => (_ctx.showTonImage(data.ton_image_path_url))
                          }, _toDisplayString(_ctx.$t('show_image')), 9, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                header: _ctx.$t('ticket.history.driver_notes'),
                field: "note"
              }, null, 8, ["header"]),
              (!_ctx.hiddenColumns['can_upload_photo'])
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    header: "Image"
                  }, {
                    body: _withCtx(({data}) => [
                      (data.image_path_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "pointer",
                            onClick: ($event: any) => (_ctx.showTonImage(data.image_path_url))
                          }, _toDisplayString(_ctx.$t('show_image')), 9, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.canUploadImage(data.status))
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 1,
                            for: 'image_' + data.id,
                            class: "p-button p-button-info p-ml-2",
                            style: {"display":"inline-block","vertical-align":"middle"}
                          }, _hoisted_14, 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        id: 'image_' + data.id,
                        hidden: "",
                        onChange: ($event: any) => (_ctx.onFileChange($event, data)),
                        type: "file",
                        multiple: false,
                        accept: "image/jpg, image/jpeg, image/png"
                      }, null, 40, _hoisted_15)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value"])
        ]))
  ], 64))
}